/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInterfaceCodeLookup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/interface_code_lookup";

export class AutogenModelInterfaceCodeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowInterfaceCodeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInterfaceCodeLookup extends ModelRow<RowInterfaceCodeLookupFields> {
	constructor(values?: Partial<RowInterfaceCodeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInterfaceCodeLookupFields {
	code_type: string;
	company_id: string;
	description: string;
	display_value: string;
	id: string;
}

